import type { PasswordChecksMap } from '@shared/validation';

import { capture } from './analytics.client';
import { AnalyticsEvent, bucketBreachCount, type PasswordRejectionSurface } from './events';

/**
 * Captures HIBP and weak-password rejections to PostHog. Call after
 * `form.submit()` when `form.invalid` and the password field's `errors`
 * contain `strength` and/or `hibp` checks.
 *
 * Privacy: never includes the password value or its hash. The HIBP breach
 * count is bucketed (see `bucketBreachCount`) so analytics can't be used
 * to fingerprint which specific leak the password came from.
 */
export function capturePasswordRejections(
  surface: PasswordRejectionSurface,
  errors: PasswordChecksMap | undefined,
): void {
  if (errors?.strength) {
    capture(AnalyticsEvent.PasswordRejectedWeak, {
      score: errors.strength.strength,
      surface,
    });
  }
  if (errors?.hibp) {
    capture(AnalyticsEvent.PasswordRejectedBreached, {
      breachCountBucket: bucketBreachCount(errors.hibp.breachCount),
      surface,
    });
  }
}
